import { Record } from 'immutable';
import { schema } from 'normalizr';

export const RelaySchedule = new Record({
  id: undefined,
  on_time: undefined,
  off_time: undefined,
  on_offset: 0,
  off_offset: 0,
  on_type: undefined,
  off_type: undefined,
  enabled: undefined,
  days_of_week: undefined,
  always_on: undefined,
  schedule_number: undefined,
  last_set_by_charting: undefined,
  relay: undefined,
  duty_cycle: undefined,
  frequency: undefined,
});

export const relayScheduleSchema = new schema.Entity('relaySchedules');
